import { IAutoplaySetting } from "./AutoplaySettings";

// "9007199254740991" -> 16 - 3 = 13
export const MAX_LENGTH_AMOUNT = 13;

// 10 ** (13 + 3) = 10000000000000000 - 1 = 9999999999999999
export const MAX_AMOUNT_IN_CENTS = 10 ** (MAX_LENGTH_AMOUNT + 3) - 1;

export const numberToCents = (x: number) => {
  if (typeof x !== "number") {
    return NaN;
  }

  const cents = x * 100;

  return Number.isInteger(cents) ? cents : NaN;
};

export const centsToNumber = (x: number) =>
  Number.isInteger(x) ? x / 100 : NaN;

export const isValidAmountInCents = (value: number) =>
  Number.isInteger(value) && value > 0 && value < MAX_AMOUNT_IN_CENTS;

export const stringifyAmount = (value: number) =>
  value !== null ? centsToNumber(value).toString() : "";

export const getRequiredSettings = (settings: IAutoplaySetting[]) => {
  if (!settings) {
    return [];
  }

  return settings.filter(
    setting => setting.attributes && setting.attributes.required
  );
};

export const prioritizeRequiredSettings = (
  settingA: IAutoplaySetting,
  settingB: IAutoplaySetting
): number => {
  if (settingA.attributes && settingA.attributes.required) {
    return -1;
  } else if (settingB.attributes && settingB.attributes.required) {
    return 1;
  }
  return 0;
};
